import React from "react";

import { Grid, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { useDispatch } from "react-redux";

import { AppDispatch } from "@store/store";
import { resetUserRegistration } from "../redux/registerSlice";

const LeftContainer = () => {
  const [isEnabled, setIsEnabled] = useState(false);
  const [aadhaar, setAadhaar] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();

  const handleToggle = () => {
    setIsEnabled(prev => !prev);
  };

  useEffect(() => {
    dispatch(resetUserRegistration());
  }, []);

  return (
    <Grid item xs={12} md={7} sx={{ mt: { xs: -1, md: -15 } }}>
      <Typography
        variant="h3"
        sx={{
          color: "#FFF",
          fontWeight: 800,
          fontSize: 32,
          lineHeight: 1.2,
          mb: 1.5
        }}
      >
        Welcome to the Rajmarg Pravesh Portal!
      </Typography>
      <Typography
        variant="body1"
        sx={{
          color: "#E2E8F0",
          fontSize: { xs: 14, md: 14 },
          fontWeight: 500,
          maxWidth: { xs: "100%", md: 800, lg: 960 }
        }}
      >
        This portal enables submission and processing of No Objection
        Certificate (NOC) applications for Right of Way (ROW) and Access
        Permissions along National Highways, including fuel stations, wayside
        amenities, private properties, industrial and public utilities (OFC,
        pipelines, electrical wires, etc.). Applications are evaluated for
        safety, technical feasibility, legal compliance, and applicable fees.
      </Typography>
    </Grid>
  );
};

export default LeftContainer;
